import "./css/d5.css";

export default function MenuTemplate5({ menu, categories }) {
  const scrollToCat = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div
      className="polished-wrapper"
      style={{
        backgroundColor: menu.colors?.background || "#fafafa",
        color: menu.colors?.text || "#222",
      }}
    >
      {/* NAV */}
      <nav className="polished-nav">
        <h2 className="polished-logo">{menu.name}</h2>
        <div className="polished-nav-links">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className="polished-nav-btn"
              onClick={() => scrollToCat(cat.id)}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </nav>

      {/* HERO */}
      <header className="polished-hero">
        {menu.imageUrl && (
          <img src={menu.imageUrl} alt="" className="polished-hero-img" />
        )}

        <div className="polished-hero-overlay">
          <h1
            className="polished-hero-title"
            style={{color: "#fff" }}
          >
            {menu.name}
          </h1>
          {menu.tagline && (
            <p  style={{color: "white"}} className="polished-hero-sub">{menu.tagline}</p>
          )}
        </div>
      </header>

      {/* FLOATING CAT BAR */}
      <div className="polished-cat-scroll">
        {categories.map((cat) => (
          <span
            key={cat.id}
            onClick={() => scrollToCat(cat.id)}
            className="polished-cat-pill"
            style={{
              backgroundColor: menu.colors?.primary || "#2e7d32",
              zIndex: 100
            }}
          >
            {cat.name}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <main className="polished-content">
        {categories.map((cat) => (
          <section
            key={cat.id}
            id={cat.id}
            className="polished-section fade-up"
            style={{
              backgroundColor: menu.colors?.card || "#fff",
            }}
          >
            <h2
              className="polished-section-title"
              style={{
                borderLeft: `4px solid ${menu.colors?.primary || "#2e7d32"}`,
              }}
            >
              {cat.name}
            </h2>

            <div className="polished-grid">
              {cat.items.map((item) => (
                <div key={item.id} className="polished-card fade-up-delayed">
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="polished-card-img"
                    />
                  )}

                  <div className="polished-card-info">
                    <h3 className="polished-card-name">{item.name}</h3>

                    {item.description && (
                      <p className="polished-card-desc">{item.description}</p>
                    )}
                  </div>

                  <span
                    className="polished-card-price"
                    style={{ color: menu.colors?.primary || "#2e7d32" }}
                  >
                    ${parseFloat(item.price).toFixed(2)}
                  </span>
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}
